import {createSlice} from '@reduxjs/toolkit';
import {httpGet, httpPost} from '../../../util/Rest';
import {ACCOUNTMULTIPLES, ACCOUNTSUMMARY} from '../../../constants/MicroServiceConstants';
import {STATUS_CHIPS} from '../../../constants/Lookup';

const initialData = {
  columnDataW3: [],
  columnStatusW3: null,
  multipleAccountInfoData: {},
  multipleAccountsData: [],
  accountInfoData: {},
  dropDownStatusData: [],
  multipleAccountSatus: null,
  isLoadingW3: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: 'multipleAccountInformation',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoadingW3 = true;
      state.errorMsg = null;
    },
    fetchColumnData: (state, action) => {
      state.columnDataW3 = action.payload;
      state.isLoadingW3 = false;
      state.errorMsg = null;
      // state.successMsg = null;
    },
    postcolumnData: (state, action) => {
      state.columnStatusW3 = action.payload.status;
      state.isLoadingW3 = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    getMultipleAccountInfo: (state, action) => {
      state.multipleAccountInfoData = action.payload;
      state.isLoadingW3 = false;
      state.errorMsg = null;
    },
    getMultipleAccounts: (state, action) => {
      state.multipleAccountsData = action.payload;
      state.isLoadingW3 = false;
      state.errorMsg = null;
    },
    getAccountInfo: (state, action) => {
      state.accountInfoData = action.payload;
      state.isLoadingW3 = false;
      state.errorMsg = null;
    },
    fetchStatusDropDownData: (state, action) => {
      state.dropDownStatusData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    postMultipleAccountInfo: (state, action) => {
      state.multipleAccountSatus = action.payload.status;
      state.isLoadingW3 = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoadingW3 = false;
    },
    resetMsg: (state) => {
      state.isLoadingW3 = false;
      state.errorMsg = null;
      state.successMsg = null;
    },
    resetStatus: (state) => {
      state.columnStatusW3 = null;
    },
    resetData: (state) => {
      state.multipleAccountInfoData = {};
      state.multipleAccountsData = [];
      state.accountInfoData = {};
      state.multipleAccountSatus = null;
    },
  },
});

export default slice.reducer;

// Actions

const {
  getMultipleAccountInfo,
  getAccountInfo,
  getMultipleAccounts,
  resetMsg,
  postMultipleAccountInfo,
  fetchStatusDropDownData,
  fetchStart,
  fetchError,
  resetData,
  fetchColumnData,
  postcolumnData,
  resetStatus,
} = slice.actions;
export const fetchW3Columns = (createdBy) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`${ACCOUNTSUMMARY}/find/columnname/W3/${createdBy}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchColumnData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const postW3Columns = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${ACCOUNTSUMMARY}/update/columnname`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postcolumnData(data));
        } else {
          dispatch(fetchError(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchMultipleAccountInformation = (accountNumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`${ACCOUNTMULTIPLES}/find/${accountNumber}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getMultipleAccountInfo(data.response));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchMultipleAccounts = (accountNumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`${ACCOUNTMULTIPLES}/find/all/${ACCOUNTMULTIPLES}/${accountNumber}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getMultipleAccounts(data.response));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchAccountInformation = (accountNumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    // http://65.0.39.33:9091/api/v1/accountmultiples/find/accountmultiples/{accountNumber}
    httpGet(`${ACCOUNTMULTIPLES}/find/${ACCOUNTMULTIPLES}/${accountNumber}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getAccountInfo(data.response));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const postAccountInfo = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${ACCOUNTMULTIPLES}/save`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postMultipleAccountInfo(data));
        } else {
          dispatch(fetchError(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const getStatusData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost('lookup/find/all/statuslookup', {
      typeCode: [STATUS_CHIPS],
    })
      .then((data) => {
        if (data && data?.status && data?.status === 200) {
          dispatch(fetchStatusDropDownData(data?.data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const resetToast = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};
export const resetAccData = () => {
  return (dispatch) => {
    dispatch(resetData());
  };
};
export const resetW3ColumnStatus = () => {
  return (dispatch) => {
    dispatch(resetStatus());
  };
};
